import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <h2 className="section-title animate-fade-in-up">About Totalguard Workwear Rosslyn</h2>
        
        <div className="about-content">
          <div className="about-text animate-fade-in-left">
            <p>
              Totalguard Workwear Rosslyn is your trusted partner in Personal Protective Equipment, dedicated to providing 
              exceptional safety solutions for industries and individuals across various sectors. With years 
              of experience in the safety industry, we understand the critical importance of reliable, 
              high-quality protective equipment.
            </p>
            <p>
              Our commitment goes beyond just selling PPE – we're building partnerships that protect lives 
              and enhance workplace safety. Every product in our range is carefully selected to meet the 
              highest standards of quality, durability, and comfort, ensuring that our customers can focus 
              on their work with complete confidence in their safety.
            </p>
            <p>
              From construction sites to manufacturing facilities, from industrial applications to personal 
              use, Totalguard Workwear Rosslyn provides comprehensive safety solutions tailored to meet diverse industry 
              needs and requirements.
            </p>
          </div>
          
          <div className="about-highlights animate-fade-in-right">
            <div className="highlight-card">
              <div className="highlight-icon"></div>
              <h4>Quality Assured</h4>
              <p>All our products meet the highest industry standards and safety certifications.</p>
            </div>
            
            <div className="highlight-card">
              <div className="highlight-icon"></div>
              <h4>Fast Delivery</h4>
              <p>Quick and reliable service to ensure you have the protection you need when you need it.</p>
            </div>
            
            <div className="highlight-card">
              <div className="highlight-icon"></div>
              <h4>Industry Focused</h4>
              <p>Specialized solutions designed for specific industry requirements and challenges.</p>
            </div>
            
            <div className="highlight-card">
              <div className="highlight-icon"></div>
              <h4>Trusted Partner</h4>
              <p>Building long-term relationships through reliable service and dependable products.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
